export enum TempleAnalyticsActionTypes {
    API_RESPONSE_SUCCESS = '@@templeAnalytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@templeAnalytics/API_RESPONSE_ERROR',

    GET_TEMPLE_DASHBOARD = '@@templeAnalytics/GET_TEMPLE_DASHBOARD',

    RESET = '@@templeAnalytics/RESET',
}